import { BehaviorService } from '@_services/Behavior.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { ChangePasswordComponent } from 'src/app/main/change-password/change-password.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityComponent implements OnInit, OnDestroy {
  isTabShow!: number;
  AWAITING2FA: any;
  showActive: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    public dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router,
    private behaviorService: BehaviorService,
    private cdr: ChangeDetectorRef,
  ) {
    this.behaviorService.AWAITING2FA$.pipe(takeUntil(this._unsubscribeAll$)).subscribe({
      next: (res: any) => {
        this.AWAITING2FA = res;
        this.cdr.markForCheck();
      },
    });
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * This function is used to chage the password data
   */
  ChangePass(): void {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      disableClose: true,
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (result: any) => {
          this.cdr.markForCheck();
        },
      });
  }

  /**
   * This function is used to target the new tab
   * @param URL -url data
   * @param modul -module data
   */
  targetNewTab(URL: any, modul: string): void {
    const currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.OPENINNEWTAB) {
      const url: string = this.router.serializeUrl(this.router.createUrlTree([URL]));
      let target: string;
      if (/[,\-|\/]/.test(URL)) {
        target = URL.replace(/-|\//g, '');
      } else {
        target = URL;
      }
      if (environment.ISPRO) {
        this.commonFocusWindow('/#' + url, target);
      } else {
        this.commonFocusWindow('/#' + url, target);
      }
    } else {
      setTimeout(() => {
        this.router.navigate([URL]).then(() => {
          this.cdr.markForCheck();
        });
      }, 100);
    }
  }

  /**
   * This function is used to common focus windows
   * @param url -url data value
   * @param modul -modul data value
   */
  commonFocusWindow(url: string, modul: string): void {
    const newWindow: any = window.open(url, modul);
    if (newWindow) {
      newWindow.focus();
    }
  }
}
